// extracted by mini-css-extract-plugin
export var container = "_ml-0";
export var dotAnimation = "_ml-2";
export var dotsLoading = "_ml-1";